import { graphqlRequest } from '~/lib/graphql-client';
import { enqueueKeyedWrite } from '~/utils/writeQueue';
import {
  UpdateCartTransportDocument,
  type UpdateCartTransportMutationVariables,
} from '~/graphql/graphql';

export function updateCartTransport(
  variables: UpdateCartTransportMutationVariables
) {
  return enqueueKeyedWrite(`cart-transport:${variables.cartId}`, () =>
    graphqlRequest(UpdateCartTransportDocument, variables)
  );
}
